// Importing with this method lazy loads the route. Better for performance
const ClientView = () => import('@/Client/ClientView.vue')
const ClientRootView = () => import('@/Client/views/RootView.vue')
const ClientWatchView = () => import('@/Client/views/Watch/WatchView.vue')

const routes = [
  {
    path: '/client',
    name: 'client',
    component: ClientView,
    children: [
      {
        path: '',
        name: 'clientRoot',
        component: ClientRootView
      },
      {
        path: 'watch/:id',
        name: 'watchContent',
        component: ClientWatchView,
        meta: {
          isEmbed: false
        }
      },
      {
        path: 'embed/:id',
        name: 'embedContent',
        component: ClientWatchView,
        meta: {
          isEmbed: true
        }
      }
    ]
  }
]

export default routes
